import { mapPinOff, mapPinOn } from '../../assets/svg/mapPinsSvg';

const defaultLocation = {
  lat: 59.33,
  lng: 18.0,
};

const libraries: ('places' | 'marker')[] = [
  'places',
  'marker',
];

const defaultZoom = 16;

const rectangleOptions = {
  fillColor: 'rgba(53, 125, 66, 0.6)',
  strokeColor: '#1b1b1b',
  strokeOpacity: 0.8,
  strokeWeight: 3,
  zIndex: 1,
};

const polygonDrawOptions = {
  fillColor: '#10172a',
  strokeColor: '#10172a',
  strokeOpacity: 1.0,
  strokeWeight: 2,
  fillOpacity: 0.5,
  clickable: true,
  editable: true,
  draggable: true,
  zIndex: 1,
};

const polygonOptions = {
  fillOpacity: 0.5,
  fillColor: 'rgb(30, 41, 59)',
  strokeColor: 'rgb(53, 125, 66)',
  strokeOpacity: 0.8,
  strokeWeight: 20,
  clickable: false,
  draggable: false,
  editable: false,
  geodesic: false,
  zIndex: 1
};

const checkIfMarkersAlreadyFit = (
  mapBounds: google.maps.LatLngBounds | undefined,
  zoomPoints: (google.maps.LatLng | google.maps.LatLngLiteral)[]
) =>
  mapBounds
    ? zoomPoints.every(
        (point: google.maps.LatLng | google.maps.LatLngLiteral) =>
          mapBounds.contains(point)
      )
    : false;

const geocodeAddress = (address: string): Promise<google.maps.LatLng> => {
  return new Promise((resolve, reject) => {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ address }, (results, status) => {
      if (status === 'OK' && results && results[0]) {
        resolve(results[0].geometry.location);
      } else {
        reject(`Geocode was not successful: ${status}`);
      }
    });
  });
};

//fit the map around markers and its centers and don't zoom in if all markers already fits
const fitBoundsAroundCenter = (
  center: google.maps.LatLng | google.maps.LatLngLiteral,
  bounds: google.maps.LatLngBounds,
  map: google.maps.Map | null,
  isMapClicked: boolean
) => {
  if (map) {
    const mapBounds = map.getBounds();
    const zoomPoints = [center, bounds.getNorthEast(), bounds.getSouthWest()];
    const allPointsInView = checkIfMarkersAlreadyFit(mapBounds, zoomPoints);

    if (!allPointsInView || !isMapClicked) {
      map.fitBounds(bounds, 100);
      map.setCenter(center);

      let allInView = false;
      if (map.getBounds()) {
        while (false === allInView) {
          const zoom = map.getZoom() || 16;
          map.setZoom(zoom - 1);
          allInView = zoomPoints.every((point) => {
            const newBounds = map.getBounds() || null;
            if (newBounds) {
              if (newBounds.contains(point)) {
                return true;
              }
              return false;
            } else return false;
          });
        }
      }
    }
  }
};

const createMarkerElement = (index: number, isSelected?: boolean) => {
  const pinElement = document.createElement('div');
  pinElement.style.position = 'relative';
  pinElement.style.cursor = 'pointer';

  // Use DOMParser to safely parse SVG (Trusted Types compliant)
  const parser = new DOMParser();
  const svgString = isSelected ? mapPinOn : mapPinOff;
  const svgDoc = parser.parseFromString(svgString, 'image/svg+xml');
  const svgElement = svgDoc.documentElement;
  svgElement.style.pointerEvents = 'none';
  pinElement.appendChild(svgElement);

  const textElement = document.createElement('div');
  textElement.style.position = 'absolute';
  textElement.style.top = '43%';
  textElement.style.left = index < 9 ? '50%' : '47%';
  textElement.style.transform = 'translate(-50%, -50%)';
  textElement.style.color = 'white';
  textElement.style.fontSize = '12px';
  textElement.style.fontFamily = 'Arial, sans-serif';
  textElement.style.pointerEvents = 'none';
  textElement.textContent = index || index === 0 ? (index + 1).toString() : '';
  pinElement.appendChild(textElement);

  return pinElement;
};

const createDrawMarkerElement = () => {
  const pinElement = document.createElement('div');

  const textElement = document.createElement('div');
  textElement.style.position = 'absolute';
  textElement.style.width = '10px';
  textElement.style.height = '10px';
  textElement.style.backgroundColor = '#10172a';
  textElement.style.top = '50%';
  textElement.style.borderRadius = '50%';
  textElement.style.left = '50%';
  textElement.style.transform = 'translate(-50%, -50%)';
  pinElement.appendChild(textElement);

  return pinElement;
};

export {
  libraries,
  defaultZoom,
  rectangleOptions,
  defaultLocation,
  polygonOptions,
  polygonDrawOptions,
  geocodeAddress,
  fitBoundsAroundCenter,
  createMarkerElement,
  createDrawMarkerElement,
};
